import React, { useState } from 'react';
import ExcelUpload from '../components/ExcelUpload';
import OrdersUpload from '../components/OrdersUpload';
import CorrectionUpload from '../components/CorrectionUpload';
import StatementsUploadAll from '../components/StatementsUploadAll';

const Correction = ({ user }) => {
    // Определяем доступные пункты меню в зависимости от роли
    const allMenuItems = [
        { key: 'accounts', label: 'Загрузка лицевых счетов', roles: ['admin'] },
        { key: 'orders', label: 'Загрузка/Обновление приказов', roles: ['admin', 'lawyer'] },
        { key: 'statementsAll', label: 'Загрузка всех выписок', roles: ['admin', 'accountant'] },
    ];

    const role = user?.role || '';
    const menuItems = allMenuItems.filter(item => item.roles.includes(role));

    // Устанавливаем первый доступный пункт как активный по умолчанию
    const [activeSection, setActiveSection] = useState(menuItems.length > 0 ? menuItems[0].key : '');

    return (
        <div className="page">
            <h2>Корректировка</h2>

            {/* Горизонтальная панель кнопок */}
            <div className="page-header" style={{ justifyContent: 'flex-start', gap: '15px' }}>
                {menuItems.map(item => (
                    <button
                        key={item.key}
                        onClick={() => setActiveSection(item.key)}
                        className={activeSection === item.key ? 'btn-primary' : 'btn-secondary'}
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            {/* Основной контент */}
            <div className="correction-content" style={{ marginTop: '20px' }}>
                {activeSection === 'accounts' && <ExcelUpload />}
                {activeSection === 'orders' && <OrdersUpload />}
                {activeSection === 'correction' && <CorrectionUpload />}
                {activeSection === 'statementsAll' && <StatementsUploadAll />}
            </div>
        </div>
    );
};

export default Correction;
